<template>
  <div class="queue-footer">
    <div class="stats">
      <div class="stat-item">
        <span class="stat-label">完了:</span>
        <span class="stat-value">{{ storageStore.queueStats.completed }}</span>
      </div>
      <div class="stat-item" v-if="storageStore.queueStats.failed > 0">
        <span class="stat-label">エラー:</span>
        <span class="stat-value error">{{ storageStore.queueStats.failed }}</span>
      </div>
      <div class="stat-item" v-if="storageStore.queueStats.pending > 0">
        <span class="stat-label">待機:</span>
        <span class="stat-value">{{ storageStore.queueStats.pending }}</span>
      </div>
    </div>
    <div class="actions">
      <button 
        class="action-btn clear-btn"
        @click="clearCompleted"
        v-if="storageStore.queueStats.completed > 0"
        title="完了済みタスクをクリア"
      >
        クリア
      </button>
      <button 
        class="action-btn cancel-all-btn"
        @click="cancelAll"
        v-if="storageStore.queueStats.pending > 0 || storageStore.queueStats.processing > 0"
        title="全てキャンセル"
      >
        全キャンセル
      </button>
    </div>
  </div>
</template>

<script setup>
import { useStorageStore } from '@/stores/storageStore'
import { useDialogStore } from '@/stores/dialogStore'

const storageStore = useStorageStore()
const dialogStore = useDialogStore()

const clearCompleted = async () => {
  if (await dialogStore.showConfirmDialog('確認', '完了済みのタスクをクリアしますか？')) {
    storageStore.clearCompletedTasks()
  }
}

const cancelAll = async () => {
  if (await dialogStore.showConfirmDialog('確認', '実行中・待機中の全てのタスクをキャンセルしますか？')) {
    // 実行中・待機中のタスクを全てキャンセル
    storageStore.taskQueue.forEach(task => {
      if (task.status === 'pending' || task.status === 'processing') {
        storageStore.cancelTask(task.id)
      }
    })
  }
}
</script>

<style scoped>
.queue-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  background-color: #f8f9fa;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  font-size: 12px;
}

.stats {
  display: flex;
  gap: 12px;
  align-items: center;
}

.stat-item {
  display: flex;
  align-items: center;
  gap: 4px;
}

.stat-label {
  color: #6c757d;
  font-weight: 500;
}

.stat-value {
  color: #333;
  font-weight: 600;
}

.stat-value.error {
  color: #dc3545;
}

.actions {
  display: flex;
  gap: 8px;
}

.action-btn {
  padding: 4px 8px;
  border: 1px solid #dee2e6;
  background: white;
  color: #6c757d;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.action-btn:hover {
  background-color: #e9ecef;
  color: #333;
}

.clear-btn:hover {
  background-color: #28a745;
  border-color: #28a745;
  color: white;
}

.cancel-all-btn:hover {
  background-color: #dc3545;
  border-color: #dc3545;
  color: white;
}
</style>